export default __webpack_public_path__ + "static/qt-sweetcombe-marque-4-star-orange-rgb-c2acdb1ed14ab78859812f5c9ba3b662.png";